import * as CreDtos from "../CRE.dtos";

export const
    CONTACTUSSETTINGS_REQUEST = "CONTACTUSSETTINGS_REQUEST",
    CONTACTUSSETTINGS_REQUEST_FAILURE = "CONTACTUSSETTINGS_REQUEST_FAILURE",
    CONTACTUSSETTINGS_REQUEST_SUCCESS = "CONTACTUSSETTINGS_REQUEST_SUCCESS",
    CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST = "CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST",
    CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST_FAILURE = "CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST_FAILURE",
    CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS = "CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS"

export function contactUsSettingsRequest() {
    return {
        type: CONTACTUSSETTINGS_REQUEST
    };
}

export function contactUsSettingsRequestSuccess(contactUsSettings: CreDtos.ContactUsSettings) {
    return {
        type: CONTACTUSSETTINGS_REQUEST_SUCCESS,
        contactUsSettings
    };
}

export function contactUsSettingsRequestFailure(error) {
    return {
        type: CONTACTUSSETTINGS_REQUEST_FAILURE,
        error
    };
}

export function contactUsSettingsUpsertRequest(contactUsSettings: CreDtos.ContactUsSettings) {
    return {
        type: CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST,
        contactUsSettings
    };
}

export function contactUsSettingsUpsertRequestSuccess(contactUsSettings: CreDtos.ContactUsSettings) {
    return {
        type: CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS,
        contactUsSettings
    };
}

export function contactUsSettingsUpsertRequestFailure(error) {
    return {
        type: CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST_FAILURE,
        error
    };
}




// WEBPACK FOOTER //
// ./src/actions/contactUsSettings.actions.ts